import services from 'api/services';
import { logError } from 'util/errors';

import {
  LOAD_FEEDBACK_REQUEST,
  LOAD_FEEDBACK_SUCCESS,
  LOAD_FEEDBACK_FAILURE,
  LOAD_TEST_FAILURE,
  LOAD_TEST_REQUEST,
  LOAD_TEST_SUCCESS,
  UPDATE_FEEDBACK_FAILURE,
  UPDATE_FEEDBACK_REQUEST,
  UPDATE_FEEDBACK_SUCCESS,
} from './constants';

const { FeedbackService, TestService } = services;

export const getCandidateFeedbacks =
  ({ minDate, maxDate, test }) =>
  async (dispatch) => {
    try {
      dispatch({ type: LOAD_FEEDBACK_REQUEST });
      const data = await FeedbackService.getCandidateFeedbacks({ minDate, maxDate, test });
      dispatch({ type: LOAD_FEEDBACK_SUCCESS, data: data });
    } catch (ex) {
      logError(ex);
      dispatch({ type: LOAD_FEEDBACK_FAILURE, error: ex.message });
    }
  };

export const getPublishedTests = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_TEST_REQUEST });
    const tests = await TestService.getPublishedTests();
    dispatch({ type: LOAD_TEST_SUCCESS, tests: tests });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_TEST_FAILURE, error: ex.message });
  }
};

export const updateCandidateFeedback = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_FEEDBACK_REQUEST });
    const statistic = await FeedbackService.updateCandidateFeedback(body);
    dispatch({ type: UPDATE_FEEDBACK_SUCCESS, data: statistic });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_FEEDBACK_FAILURE, error: ex.message });
  }
};
